import React from 'react';
import { Card, CardBody, Container } from 'reactstrap';
import { useAppSelector } from '../../../../../app/config/store';
const PrivacyPolicy = () => {
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);

  const styles: any = {
    appViewContainer: {
      padding: 0,
      backgroundColor: !isAuthenticated && '#e6f7ff',
      paddingBottom: '20px',
    },
    mainContent: {
      margin: '0 auto',
      minHeight: 'calc(100vh - 20px)',
    },
  };
  return (
    <div style={styles.appViewContainer}>
      <Container style={styles.mainContent} className="justify-content-center align-items-center ">
        {!isAuthenticated && (
          <div className="logo-icon text-center">
            <img src="content/images/cases/dyhaclogo.svg" alt="Logo" className="logo-img" />
          </div>
        )}
        <Card className="terms-card" style={isAuthenticated ? { marginLeft: '250px' } : {}}>
          <CardBody>
            <div className="title-section">
              <h4>Privacy Policy</h4>
              <p>
                <strong>Last Updated: [February 25, 2025]</strong>
              </p>
            </div>
            <br></br>
            <div className="scrollable-terms">
              {/* <p className='main-title'>
            PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING THIS SITE.
          </p> */}
              <p>
                LifeSolutions Technology LLC LLC (“LifeSolutions Technology LLC LLC,” “we,” “us,” or “our”) is committed to protecting your
                privacy as it relates to our products and services, including the Do You Have a Case (“DYHAC”) Website. This Privacy Policy
                describes how we collect, use, disclose, and protect personal information in connection with:
              </p>
              <p>
                1. Our website(s), including DYHAC and any other Websites or mobile apps where this Privacy Policy is posted or linked
                (“Digital Properties”).
              </p>
              <p>2. Any services available through the Digital Properties.</p>
              <p>3.Our offline and business interactions with you (collectively, the “Services”).</p>
              <br />
              <div className="list-style">
                <h5>Personal Information We Collect</h5>
                <p> We may collect the following categories of personal information:</p>
                <ul>
                  <li>
                    <strong> Contact Information </strong> (e.g., name, address, phone number, email)
                  </li>
                  <li>
                    <strong> Identifying Information </strong> (e.g., date of birth or other similar identifiers)
                  </li>
                  <li>
                    {' '}
                    <strong>Communications</strong>(e.g., records of interactions via email, phone, chatbot transcripts)
                  </li>
                  <li>
                    {' '}
                    <strong>Preferences</strong>(e.g., communication frequency and channels)
                  </li>
                  <li>
                    {' '}
                    <strong>Usage Information</strong> (e.g., device identifiers, IP addresses, browsing activity, cookie data)
                  </li>
                  <li>
                    {' '}
                    <strong>Other Information</strong> (e.g., any information you submit in forms or messages)
                  </li>
                </ul>
                <br></br>
                <strong> Information Collected Automatically</strong>
                <p>
                  We and our service providers use cookies, pixels, and related tracking technologies to collect details about your use of
                  the Digital Properties, such as IP address, browser characteristics, device IDs, and pages or features accessed.
                </p>
                <br></br>
                <strong> Information from Third Parties</strong>
                <p>
                  We may obtain personal information from outside sources, such as service providers, social media platforms, credit
                  bureaus, or our business partners.
                </p>
              </div>
              <br></br>
              <div className="list-style">
                <h5>How We Use Personal Information</h5>
                <p>We use your personal information to:</p>
                <ul>
                  <li>
                    <strong> Provide and Improve Services </strong> – Process requests, respond to inquiries, and enhance the user
                    experience.
                  </li>
                  <li>
                    <strong>Communicate with You</strong> – Send administrative or transactional communications and respond to your
                    questions.
                  </li>
                  <li>
                    <strong>Send Marketing and Promotional Messages</strong> – Where permitted by law, offer products or services we believe
                    may interest you.
                  </li>
                  <li>
                    <strong>Personalize Your Experience</strong> – Tailor content and recommendations.
                  </li>
                  <li>
                    <strong>Conduct Analytics</strong> – Evaluate and improve our Services and user experience.
                  </li>
                  <li>
                    <strong>Prevent Fraud and Maintain Security</strong> – Protect our Services and users from illegal or unauthorized
                    activity.
                  </li>
                  <li>
                    <strong>Satisfy Legal Obligations</strong> – Comply with applicable law and respond to lawful requests.
                  </li>
                  <li>
                    <strong>Support Business Operations</strong> – Conduct routine business administration, audits, and fulfill contractual
                    obligations.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Disclosure of Personal Information</h5>
                <p>We may disclose personal information to:</p>
                <ul>
                  <li>
                    <strong> Affiliates and Subsidiaries</strong> – Within LifeSolutions Technology LLC LLC’s corporate network for
                    consistent service.
                  </li>
                  <li>
                    <strong>Service Providers</strong> – Parties that perform functions on our behalf (marketing, analytics, hosting, etc.).
                  </li>
                  <li>
                    <strong>Marketing and Advertising Partners</strong> – To facilitate interest-based advertising and measure ad
                    performance.
                  </li>
                  <li>
                    <strong>Government and Public Authorities</strong> – As required by law or to protect legal rights.
                  </li>
                  <li>
                    <strong>Business Transactions</strong> – In the event of a merger, sale, or transfer of assets.
                  </li>
                  <li>
                    <strong>Other Parties</strong> – With your consent or as necessary to protect rights, investigate fraud, or respond to
                    lawful requests.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>SMS Privacy Statement</h5>
                <ul>
                  <li>
                    When you opt in to receive SMS messages (texts) from us, we collect your mobile phone number and any associated
                    information you provide. We use this information to send updates, offers, or other relevant content. You may opt out at
                    any time by following the instructions in those messages or contacting us directly.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Cookies and Interest-Based Advertising</h5>
                <ul>
                  <li>
                    <strong> Cookies</strong>: We use cookies and similar technologies to remember user preferences, understand usage, and
                    measure campaign effectiveness.
                  </li>
                  <li>
                    <strong>Analytics</strong>: Tools like Google Analytics help us analyze site traffic and usage patterns.
                  </li>
                  <li>
                    <strong>Interest-Based Ads</strong>: We may partner with third-party ad networks (e.g., Google, Meta, TikTok) to display
                    relevant ads across other websites and apps.
                  </li>
                  <li>
                    <strong>Your Choices</strong>: Adjust your browser or device settings to disable cookies, or use industry opt-out tools
                    (e.g., DAA or NAI).
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>ChatBot Technology</h5>
                <ul>
                  <li>
                    Our chatbot uses machine learning and generative AI for automated assistance. Your conversations may be recorded; please
                    do not share sensitive data. We are not liable for any inaccuracies that may arise from chatbot responses. We may use
                    chat transcripts for fraud prevention, quality control, and internal analytics.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Use of Website Analytics and CRM Software</h5>
                <p>
                  Where implemented, CRM software scripts capture and store data about website interactions (e.g., what is displayed on the
                  screen, mouse movements, typed text) to verify consent. This data is not used to track or target you beyond verifying and
                  documenting your opt-in or consent to contact.
                </p>
                <br></br>
                <p>
                  We use<strong>Website Analytics</strong>and <strong>CRM Software</strong> to analyze user activity, improve website
                  functionality, and tailor user experiences. These services may collect information about:
                </p>
                <br />
                <ul>
                  <li>Pages visited, time spent on pages, and navigation patterns.</li>
                  <li>Device and browser information.</li>
                  <li>IP addresses and geolocation data.</li>
                  <li>Referral sources (e.g., how users arrived at our website).</li>
                </ul>
                <br></br>
                <strong>Google Analytics</strong>
                <p>
                  Google Analytics may use cookies and tracking pixels to collect data. You can opt out of Google Analytics tracking by
                  using the Google Analytics Opt-Out Browser Add-on.
                </p>
                <br></br>
                <strong>HubSpot</strong>
                <p>
                  HubSpot may collect contact information, form submissions, and user interactions with our website and email
                  communications. HubSpot's privacy policy can be found at{' '}
                  <a href="https://legal.hubspot.com/privacy-policy"> HubSpot Privacy Policy</a> .
                </p>
              </div>
              <div className="list-style">
                <h5>Data Confidentiality</h5>
                <ul>
                  <li>We prioritize user data confidentiality and implement security measures to protect stored data.</li>
                  <li>
                    No human eyes will review or access user data except when required to fulfill the services described on the Websites,
                    such as responding to user inquiries, maintaining system integrity, or complying with legal obligations.
                  </li>
                  <li>
                    User data is processed automatically through secure, encrypted systems, and access is limited to authorized personnel
                    strictly on a need-to-know basis.
                  </li>
                  <li>
                    We do not sell, trade, or otherwise disclose personal data beyond what is necessary to provide the requested services or
                    comply with applicable law.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Dispute Resolution & Governing Law</h5>
                <ul>
                  <li>
                    Any dispute relating to the Websites, Content, or Services shall be exclusively resolved by binding individual
                    arbitration administered by the American Arbitration Association under its Consumer Arbitration Rules.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Your Choices</h5>
                <ul>
                  <li>
                    <strong>Opt Out of Marketing</strong>: To stop receiving marketing emails, click “unsubscribe” in any email or contact
                    [info@doyouhaveacase.com].
                  </li>
                  <li>
                    <strong>Cookies</strong>: You can refuse or delete cookies by adjusting your browser settings.
                  </li>
                  <li>
                    <strong>Interest-Based Advertising</strong>: Use browser or device-based options or visit industry opt-out pages.
                  </li>
                  <li>
                    <strong>Access and Correction</strong>: Contact us if you wish to access or correct personal information, subject to any
                    legal limitations.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Security</h5>
                <ul>
                  <li>
                    We maintain reasonable safeguards to protect your information but cannot guarantee absolute security. You use our
                    Services at your own risk.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Information Retention</h5>
                <ul>
                  <li>
                    We retain personal information as long as necessary to fulfill the purposes outlined here, subject to legal obligations.
                    We will then delete or de-identify the data, unless otherwise permitted by law.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Third-Party Services</h5>
                <ul>
                  <li>
                    Our Digital Properties may link to websites or services operated by third parties. We are not responsible for their
                    content or privacy practices. We recommend reviewing each third party’s privacy policy.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Children’s Privacy</h5>
                <ul>
                  <li>
                    Our Services are intended for individuals over 18 years of age. We do not knowingly collect personal information from
                    children under 18.
                  </li>
                </ul>
              </div>

              <div className="list-style">
                <h5>Services Limited to the United States</h5>
                <ul>
                  <li>
                    Our Services are designed for individuals located in the United States and governed by U.S. law. If you access the
                    Services from outside the U.S., you agree to the transfer of your information in accordance with this policy.
                  </li>
                </ul>
              </div>

              <div className="list-style">
                <h5>Changes to This Privacy Policy</h5>
                <ul>
                  <li>
                    We may update this Privacy Policy from time to time. The “Last Updated” date reflects the latest revision. Material
                    changes will be posted on the Digital Properties, and your continued use constitutes acceptance of those changes.
                  </li>
                </ul>
              </div>

              <div className="list-style">
                <h5>Contact Us</h5>
                <ul>
                  <li>If you have questions or concerns about this Privacy Policy or our data practices, contact us at:</li>
                </ul>
                <br />
                <p>LifeSolutions Technology LLC</p>
                <p>LLC [Address Placeholder] </p>
                <p>Email: [info@doyouhaveacase.com]</p>
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
